if (!customElements.get('slider-controls')) {
  customElements.define('slider-controls', class SliderControls extends HTMLElement {
    constructor() {
      super();
      this._syncRaf = null;
      this._boundScheduleSync = this.scheduleSync.bind(this);
      this._syncViewers = [];
    }

    connectedCallback() {
      if (!this.hasAttribute('data-clone') || !this.dataset.id) return;

      const section = this.closest('.shopify-section');
      if (!section) return;

      const originals = Array.from(section.querySelectorAll(`slider-controls[data-id="${this.dataset.id}"][data-origin]`));
      if (!originals.length) return;

      const isCurrent = el =>
        el && (el.offsetParent !== null ||
          el.closest('.tabs__tab-content--active') ||
          (el.closest('.heading-wrapper')?.querySelector('.tabs__list') === null));

      const original = originals.length === 1 ? originals[0] : (originals.find(isCurrent) || originals[0]);
      if (!original) return;

      const cloneButtons = this.querySelectorAll('button');
      const originalButtons = original.querySelectorAll('button');

      if (cloneButtons.length === 2 && originalButtons.length === 2) {
        const syncDisabled = () => {
          const currentOrig = originals.length === 1 ? originals[0] : (originals.find(isCurrent) || original);
          const origButtons = currentOrig.querySelectorAll('button');

          cloneButtons.forEach((btn, i) => {
            const isDisabled = origButtons[i]?.disabled;
            
            if (isDisabled) {
              btn.setAttribute('disabled', '');
              btn.disabled = true;
            } else {
              btn.removeAttribute('disabled');
              btn.disabled = false;
            }
          });
        };

        cloneButtons.forEach((btn, i) => {
          btn.addEventListener('click', () => {
            const currentOrig = originals.length === 1 ? originals[0] : (originals.find(isCurrent) || originals[0]);
            const targetButton = currentOrig?.querySelectorAll('button')[i];
            targetButton?.click();
            
            setTimeout(() => syncDisabled(), 50);
          });
        });

        syncDisabled();
        setTimeout(syncDisabled, 0);
        setTimeout(syncDisabled, 100);

        const buttonObserver = new MutationObserver(() => {
          this.scheduleSync();
        });
        originals.forEach(orig =>
          orig.querySelectorAll('button').forEach(btn =>
            buttonObserver.observe(btn, { attributes: true, attributeFilter: ['disabled'] })
          )
        );

        this._buttonObserver = buttonObserver;
        this._syncDisabled = syncDisabled;
      }

      const cloneCounter = this.querySelector('.slider-counter');
      if (!cloneCounter) return;

      const getCurrent = () => {
        return originals.length === 1 ? originals[0].querySelector('.slider-counter')
          : (originals.find(isCurrent) || original).querySelector('.slider-counter');
      };

      const updateVars = () => {
        const origCounter = getCurrent();
        if (!origCounter) return;
        
        const current = origCounter.style.getPropertyValue('--slider-counter-current');
        const total = origCounter.style.getPropertyValue('--slider-counter-total');
        
        if (current) cloneCounter.style.setProperty('--slider-counter-current', current);
        if (total) cloneCounter.style.setProperty('--slider-counter-total', total);
        return current || total;
      };

      updateVars();

      const styleObserver = new MutationObserver(() => {
        this.scheduleSync();
      });
      
      originals.forEach(orig => {
        const target = orig.querySelector('.slider-counter');
        if (target) {
          styleObserver.observe(target, { attributes: true, attributeFilter: ['style'] });
        }
      });

      this._styleObserver = styleObserver;
      this._updateVars = updateVars;

      const viewerSet = new Set();
      originals.forEach((orig) => {
        const viewer = orig.closest('[id^="GalleryViewer"], slider-component');
        if (!viewer || viewerSet.has(viewer)) return;
        viewerSet.add(viewer);
        viewer.addEventListener('slideChanged', this._boundScheduleSync);
      });
      this._syncViewers = Array.from(viewerSet);
    }

    sync() {
      this._syncDisabled?.();
      return !!(this._updateVars?.() || this._syncDisabled);
    }

    scheduleSync() {
      if (this._syncRaf) return;
      this._syncRaf = requestAnimationFrame(() => {
        this._syncRaf = null;
        this._syncDisabled?.();
        this._updateVars?.();
      });
    }

    disconnectedCallback() {
      this._styleObserver?.disconnect();
      this._buttonObserver?.disconnect();
      if (this._syncRaf) cancelAnimationFrame(this._syncRaf);
      this._syncViewers.forEach((viewer) => viewer.removeEventListener('slideChanged', this._boundScheduleSync));
      this._syncViewers = [];
    }
  });
}
